export const ALARM_CATEGORY_COLOR = {
  Failed: "#EA4C32",
  Information: "#506EFF",
  // Maintenance: "#5C7E8E",
  Prediction: "#4BB157",
  Threshold: "#FE9700",
  Testing: "#7D7D7D",
  False: "#D3D3D3",
};

export const ATTACHMENT_TYPES = [
  "Technical specs",
  "Data sheets",
  "user manual",
  "Maintenance manual",
  "RDSO specs",
  "Inspection report",
  "Drawing",
  "SIP",
  "CCP",
  "Maintenance schedule",
  "Gear Type Image",
  "FDS Logs",
];

export const CIRCULAR_ATTACHMENT_TYPES = [
  // "Technical specs",
  // "Data sheets",
  // "user manual",
  // "Maintenance manual",
  // "RDSO specs",
  // "Inspection report",
  // "Drawing",
  // "SIP",
  // "CCP",
  // "Maintenance schedule",
  // "Gear Type Image",
  // "Maintenance Circular",
  // "Technical Circular",
  // "Policy Circular",
  "JPO",
  "Instruction",
  "Latter",
  "Specification",
  "TAN",
  "Other",
  // "MOU",
];

export const CIRCULAR_ISSUED_BY = ["Railway Board", "RDSO", "Other Zonal Railway", "South Eastern Railway"];
export const ASSET_CATEGORIES = ["Supervisiory Track", "Main Track", "Supervisory Dual Detection"];



export const INSTRUCTION_TYPE = [
  "Maintenance schedule",
  "Cable Route plan",
  "Location Particular",
  "Checklist",
  "Other",
];

export const PCCL_STORAGE_DOCUMENTS = ["Checklist", "Others"];

export const TYPICAL_DRAWING_STORAGE_DOCUMENTS = ["SIP", "Others"];